module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var util = require('util/Util').default;
var perms = currentViewerPerms ? util.enforceArrayType(currentViewerPerms) : [];
var dimAll = !selectedViewer;
var row;
var permLabels;
var isForm = !isReport;


    ; __append("\r\n\r\n<div id=\"permsDetail\">\r\n\r\n    <div class=\"row nopadding\">\r\n        <div class=\"col-md-5\">\r\n        </div>\r\n        <div class=\"col-md-3 form-label\">\r\n            <label class=\"")
    ; __append(escapeFn( dimAll ? 'dim-text' : '' ))
    ; __append("\" style=\"margin-left: -10px\">Allow</label>\r\n        </div>\r\n        <div class=\"col-md-3 form-label\">\r\n            <label class=\"")
    ; __append(escapeFn( dimAll ? 'dim-text' : '' ))
    ; __append("\" style=\"margin-left: -10px\">Deny</label>\r\n        </div>\r\n    </div>\r\n\r\n    ")
    ; 
    permLabels = isReport
        ? ['View', 'Edit', 'Publish', 'Full Control']
        : ['View', 'Edit', 'Publish', 'Data', 'API', 'Full Control'];

    // Transform form row swaps ID assignment for form row 4 and 5.
    // Form row 4 is internal "Full Control" row. Row 5 is UR "Full Control" row.
    // Reports don't have this feature.
    function xfRow( row ) {
        var rr = parseInt(row);
        if (isForm) {
            if (row === 4) {
                rr = 5;
            } else if (row === 5) {
                rr = 4;
            }
        }
        return String(rr);
    }

    row = 0;

    // Note that the following capability names no longer match all internal permissions names.
    // They match the names the Flash app shows to the user.
    // The expanded internal permission list is ordered, so we assign those items 1:1 to the six displayable view names.
    // A permssion list instance can be shorter than six, so we flag stop-matching at that point via isEnable.

    permLabels.forEach(function(v) {
        var isAllow, isDeny;
        var isEnabled = row < perms.length;
        var p;
        var isWorld = 'World' === selectedViewer;

        if (isEnabled) {
            p = perms[xfRow(row)];
            isAllow = 'allow' === p['#text'];
            isDeny = 'deny' === p['#text'];
            if (!String(p['#text']).length) {
                isAllow = isDeny = false;
            }
        }

    
    ; __append("\r\n        <div class=\"row nopadding\">\r\n            <div class=\"col-md-5 form-label\">\r\n                <label class=\"")
    ; __append(escapeFn( dimAll || isWorld && row > 0 ? 'dim-text' : '' ))
    ; __append("\">")
    ; __append(escapeFn( v ))
    ; __append("</label>\r\n            </div>\r\n            <div class=\"col-md-3 form-check\">\r\n                <input class=\"form-check-input\" type=\"checkbox\" ")
    ; __append(escapeFn(  dimAll || isWorld && xfRow(row) > 0 ? 'disabled' : '' ))
    ; __append("\r\n                    id=\"")
    ; __append(escapeFn( xfRow(row) + 'allow' ))
    ; __append("\"\r\n                    value=\"")
    ; __append(escapeFn( isAllow ))
    ; __append(">\"\r\n                    ")
    ; __append(escapeFn( isAllow ? 'checked' : '' ))
    ; __append("\r\n                       aria-label=\"...\">\r\n            </div>\r\n            <div class=\"col-md-3 form-check\">\r\n                <input class=\"form-check-input\" type=\"checkbox\"  ")
    ; __append(escapeFn(  dimAll || isWorld && xfRow(row) > 0 ? 'disabled' : '' ))
    ; __append("\r\n                    id=\"")
    ; __append(escapeFn(  xfRow(row) + 'deny' ))
    ; __append("\"\r\n                    value=\"")
    ; __append(escapeFn( isDeny ))
    ; __append(">\"\r\n                    ")
    ; __append(escapeFn( isDeny ? 'checked' : '' ))
    ; __append("\r\n                       aria-label=\"...\">\r\n            </div>\r\n        </div>\r\n    ")
    ; 
        row++;
    });
    
    ; __append("\r\n\r\n\r\n</div>")
  }
  return __output;

}